import { useModalStore } from "../../../stores/modalStore";
import { ModalBackdrop, ModalContentWrapper, ModalDialog } from "./styles";

export default function Modal() {
  const { isModalOpen, Content, options, closeModal } = useModalStore();

  const handleBackdropClick = () => {
    if (options?.disableBackdropClick) return;
    closeModal();
  }

  const shouldShowBackdrop = isModalOpen && !(options?.hideBackdrop);
  const backdropZ = options?.backdropZIndex ?? 1999; //por encima del header

  return (
    <ModalDialog
      open={isModalOpen}
      isOpen={isModalOpen}
      className={isModalOpen ? "open" : ""}
      aria-modal="true"
      aria-labelledby={options?.ariaLabelledBy}
      role="dialog"
    >
      {shouldShowBackdrop && (
        <ModalBackdrop
          z={backdropZ}
          onClick={handleBackdropClick}
        />
      )}
      {isModalOpen ? (
        <ModalContentWrapper allowOverflow={options?.allowOverflow}>
          {Content}
        </ModalContentWrapper>
      ) : null}
    </ModalDialog>
  );
}